import React from 'react';

interface SportIconProps {
    category?: string;
    size?: number;
    className?: string;
}

const SportIcon: React.FC<SportIconProps> = ({ category, size = 20, className }) => {
    const isCricket = category === 'Cricket';
    const isFootball = category === 'Football';

    if (isCricket) {
        return (
            <svg
                className={className}
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
            >
                <rect x="3" y="14" width="18" height="3" rx="1.5" fill="currentColor" opacity="0.35" />
                <path
                    d="M7 4l3 16M17 4l-3 16M5 8h14M6 12h12"
                    stroke="currentColor"
                    strokeWidth="1.75"
                    strokeLinecap="round"
                />
            </svg>
        );
    }

    if (isFootball) {
        return (
            <svg
                className={className}
                width={size}
                height={size}
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
            >
                <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.75" />
                <path
                    d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1"
                    stroke="currentColor"
                    strokeWidth="1.25"
                    strokeLinecap="round"
                />
                <circle cx="12" cy="12" r="2.5" fill="currentColor" opacity="0.5" />
            </svg>
        );
    }

    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
        >
            <rect x="4" y="6" width="16" height="12" rx="2" stroke="currentColor" strokeWidth="1.75" />
            <path d="M9 10h6M9 14h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    );
};

export default SportIcon;
